import React from 'react';
import { CheckIcon } from 'lucide-react';
import { product, productModules } from '../data/product';
export function MainProduct() {
  return <section className="px-5 py-20 md:py-28" aria-labelledby="produit-title" data-id="element-131" data-mp="3cj2tv9rrxxwn">
      <div className="mx-auto grid max-w-6xl items-center gap-12 md:grid-cols-[1.1fr_1fr] md:gap-16" data-id="element-132" data-mp="38jk9cf3v7ouc">
        <div data-id="element-133" data-mp="33l8yq25qxab2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold" data-id="element-134" data-mp="33liphrym7lht">{product.tagline}</p>
          <h2 id="produit-title" className="mt-4 font-display text-5xl uppercase leading-none text-cream md:text-7xl" data-id="element-135" data-mp="42gd8cszov6f">
            {product.name}
          </h2>
          <p className="mt-6 max-w-xl font-serif text-lg italic leading-relaxed text-cream-muted" data-id="element-136" data-mp="3r87dmve7wa6v">{product.description}</p>
          <ul className="mt-8 space-y-3" data-id="element-137" data-mp="3m9nrouzmiyei">
            {productModules.map(m => <li key={m} className="flex gap-3 text-cream/90" data-id="element-138" data-mp="2fuwgnygsdx6r">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-139" data-mp="2auh6tgvpr7tj" />
                {m}
              </li>)}
          </ul>
          <p className="mt-8 text-sm text-cream-muted" data-id="element-140" data-mp="39yzoalbqwsb0">
            Valeur <span className="ml-1 font-display text-3xl text-cream" data-id="element-141" data-mp="3e1nzv0rugdbo">{product.value} $</span>
          </p>
        </div>
        <img src={product.image} alt="Fiche de cours Le Jazz Master imprimée sur un bureau" className="aspect-[4/3] w-full rounded-2xl object-cover" data-id="element-142" data-mp="302egxtc97540" />
      </div>
    </section>;
}